import $ from 'jquery';

$(function () {
    function search_per_page() {
        const elem = $(this);
        const per_page = elem.val();
        let url = $('form#per_page_form').attr('action');
        if (url.includes('?')) {
            url = url + "&per_page=" + per_page;
        } else {
            url = url + "?per_page=" + per_page;
        }
        window.jixAnalytics('event', { category: 'article_search', action: 'switch-per-page', label: url });
        window.location.href = url;
    }

    function search_sorting() {
        const elem = $(this);
        const sort = elem.val();
        let url = $('form#sorting_form').attr('action');
        if (url.includes('?')) {
            url = url + "&sort=" + sort;
        } else {
            url = url + "?sort=" + sort;
        }
        window.jixAnalytics('event', { category: 'article_search', action: 'switch-sort', label: url });
        window.location.href = url;
    }

    $('select[name="per_page"]').on('change', search_per_page);
    $('select[name="sort"]').on('change', search_sorting);

    $(document).on('click', 'div#content_results div.jix_pagination li.page-item > a', function(event) {
        const url = event.target.href;
        window.jixAnalytics('event', { category: 'article_search', action: 'switch-page', label: url });
    });

    $(document).on('click', 'div#content_results div.article-card a', function() {
        const elem = $(this);
        const url = elem.attr('data-track_url');
        window.jixAnalytics('event', { category: 'article_search', action: 'click-article', label: url });
    });

    $(document).on('click', 'button#content_submit', function() {
        const action = $('form#word_content_search').attr('action');
        const search_string = $('input#q').val();
        const url = action + '?q=' + search_string;
        window.jixAnalytics('event', { category: 'article_search', action: 'search', label: url });
    });
});
